export function setDatosRci(state, payload){
    
    state.datosphp = payload.data
    state.error= false
 
}
export function datosrciError (state, payload){
    state.error = true
    state.errorMessage = payload

}
export function flushDatosRci(state){
    state.datosphp = []
    state.error= false
    state.totalRow= 0
}